// extracted by mini-css-extract-plugin
export default {"headerPage":"style_headerPage__WMuct"};